import React, { useState } from 'react';
import { Header } from './Header';
import { Problem } from './Problem';
import { Solution } from './Solution';
import { Testimonials } from './Testimonials';
import { Reviews } from './Reviews';
import { WebinarDetails } from './WebinarDetails';
import { FAQ } from './FAQ';
import { Benefits } from './Benefits';
import { CallToAction } from './CallToAction';
import { MoreTestimonials } from './MoreTestimonials';
import { Footer } from './Footer';
import { WebinarModal } from './WebinarModal';
import { StickyButton } from './StickyButton';
export const Advertorial = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => {
    window.location.href = 'https://stresslessdogs.nl/mcc-meta-adv2';
  };
  const closeModal = () => setIsModalOpen(false);
  return <div className="max-w-3xl mx-auto px-4 py-6 font-sans text-gray-800 pb-24 md:pb-6" data-id="element-6">
      <WebinarModal isOpen={isModalOpen} onClose={closeModal} data-id="element-7" />
      <Header openModal={openModal} data-id="element-8" />
      <Problem openModal={openModal} data-id="element-9" />
      <Solution openModal={openModal} data-id="element-10" />
      <Testimonials openModal={openModal} data-id="element-11" />
      <WebinarDetails openModal={openModal} data-id="element-12" />
      <Reviews data-id="element-13" />
      <FAQ openModal={openModal} data-id="element-14" />
      <Benefits openModal={openModal} data-id="element-15" />
      <CallToAction openModal={openModal} data-id="element-16" />
      <MoreTestimonials data-id="element-17" />
      <Footer openModal={openModal} data-id="element-18" />
      <StickyButton onClick={openModal} data-id="element-19" />
    </div>;
};